export const getAllData = (state, action, key) => {
  //console.log('state @ 2 : ', state)
  return {
    ...state,
    [key]: action.payload,
    loading: false,
  }
}

export const addData = (state, action, key) => {
  return {
    ...state,
    [key]: [action.payload, ...state[key]],
  }
}

export const editData = (state, action, key) => {
  const updatedData = action.payload

  const updatedDatas = state[key].map((data) => {
    if (data.id === updatedData.id) {
      return updatedData
    }
    return data
  })

  return {
    ...state,
    [key]: updatedDatas,
  }
}

export const deleteData = (state, action, key) => {
  return {
    ...state,
    [key]: state[key].filter((data) => data.id !== action.payload),
  }
}
// ["a","b"]

export const customReducer = (state, action, key = [], cases = []) => {
  //console.log('STATE : ', state)
  if (key.length > 0) {
    // for (let i in key) {

    console.log({ state })
    switch (action.type) {
      case cases[0]:
        return getAllData(state.allowanceTypes, action, key)
      case cases[1]:
        return addData(state.allowanceTypes, action, key)
      case cases[2]:
        return editData(state.allowanceTypes, action, key)
      case cases[3]:
        return deleteData(state.allowanceTypes, action, key)
      default:
        return state
    }
    // }
  }

  // switch (action.type) {
  //   key && key.forEach((val,index)=>{
  //    //
  //   })

  //   default:
  //     return state
  // }

  // key &&
  //   key.forEach((val, i) => {
  //     //console.log('INDEX : ', cases[i])
  //     switch (action.type) {
  //       case cases[i][0]:
  //         return getAllData(state, action, val)
  //       case cases[i][1]:
  //         return addData(state, action, val)
  //       case cases[i][2]:
  //         return editData(state, action, val)
  //       case cases[i][3]:
  //         return deleteData(state, action, val)
  //       default:
  //         return state
  //     }
  //   })
}
